import { render, staticRenderFns } from "./CarregandoFolha.vue?vue&type=template&id=61a4bb50"
import script from "./CarregandoFolha.vue?vue&type=script&lang=js"
export * from "./CarregandoFolha.vue?vue&type=script&lang=js"
import style0 from "./CarregandoFolha.vue?vue&type=style&index=0&id=61a4bb50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports